import { OptionsApi } from '@core/swagger-client';
import { DeepgramGenerateSubtitlesOptions } from '@core/types/src/types';
import { Button, Dialog, Loader } from '@core/ui';
import { useParams } from '@online-webinar/router';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DeepgramOptionsMolecule } from '../../molecules/DeepgramOptionsMolecule';

export const GenerateSubtitlesOptionsOrganism = ({ onClose }: { onClose: () => void }) => {
    const { webinarId } = useParams({ strict: false });

    const { t } = useTranslation();
    const { data: defaultGeneratorOptions, isLoading: isLoadingGeneratorOptions } = useQuery(OptionsApi.subtitleGenerator.getOptions(webinarId!));

    const [generatorOptions, setGeneratorOptions] = useState(defaultGeneratorOptions);
    useEffect(() => {
        setGeneratorOptions(defaultGeneratorOptions);
    }, [defaultGeneratorOptions]);

    const updateDeepgramOptions = (settings: DeepgramGenerateSubtitlesOptions) => {
        setGeneratorOptions((prevOptions) => ({
            ...prevOptions!,
            deepgram: settings
        }));
    };

    const generateSubtitlesMutatation = useMutation(OptionsApi.subtitleGenerator.generateSubtitles());
    const generateSubtitles = () => {
        generateSubtitlesMutatation.mutate(
            {
                webinarId: webinarId!,
                options: generatorOptions!
            },
            {
                onSuccess: () => {
                    onClose();
                }
            }
        );
    };

    return (
        <Dialog open={true} onClose={onClose} title={t('EditSubtitles.GenerateSubtitlesOptions.Title')}>
            {isLoadingGeneratorOptions || !generatorOptions ? (
                <Loader />
            ) : (
                <>
                    <DeepgramOptionsMolecule options={generatorOptions.deepgram} updateOptions={updateDeepgramOptions} />
                    <div className="flex flex-wrap gap-4">
                        <Button variant="primary-outline" classNames="flex-1" onClick={onClose}>
                            {t('Generic.Dialog.Button.Close')}
                        </Button>
                        {generatorOptions.deepgram.isEnabled && (
                            <Button variant="primary" classNames="flex-1 whitespace-nowrap" onClick={generateSubtitles}>
                                {t('EditSubtitles.Button.GenerateSubtitles')}
                            </Button>
                        )}
                    </div>
                </>
            )}
        </Dialog>
    );
};
